import { render, staticRenderFns } from "./SortDrawer.vue?vue&type=template&id=bf7b8a7c&scoped=true&"
import script from "./SortDrawer.vue?vue&type=script&lang=js&"
export * from "./SortDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SortDrawer.vue?vue&type=style&index=0&id=bf7b8a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7b8a7c",
  null
  
)

export default component.exports